// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { getProgressionAnalysisTrendlines } from "../../api";
import { ProgressionAnalysisTrendlinesType } from "../../types";

export const useProgressionAnalysisTrendlines = (
  clinicId: string | undefined,
  payload: { patientId: string; analysisId: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<ProgressionAnalysisTrendlinesType>({
    queryKey: ["progression-analyses", payload.analysisId, "trendlines"],
    queryFn: async ({ signal }) => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const data = await getProgressionAnalysisTrendlines(
        token,
        clinicId,
        payload.patientId,
        payload.analysisId,
        signal
      );

      return JSON.parse(data);
    },
    // Only once there's an analysis to fetch for
    enabled: Boolean(clinicId && payload.patientId && payload.analysisId),
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the reports page
  });
};
